import getStore from '../store';
import clamp from '../util/clamp';
import { maxTools, minTools, toolDims } from '../constants';

/**
 * Calculates the number of tools able to display in a given toolbox height.
 * Takes into account that the header + footer of the toolbox must always be displayed.
 */
export default function getNumDisplayedTools(): number {
    return clamp(getStore().toolboxHeight / toolDims - 2, minTools, maxTools);
}
